import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered pages (build/<route>/index.html, see scripts/prerender.js) ship
// static markup for crawlers, but it is NOT hydratable: it is a headless-browser
// DOM snapshot taken after effects and API calls settled (auth resolved, banners
// shown), and it has none of the Suspense markers React needs for the lazy
// routes. hydrateRoot always failed on it (minified React error #418) and fell
// back to a full client render anyway. createRoot replaces the static markup on
// its first commit, so render fresh instead.
ReactDOM.createRoot(container).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
